"use client";

import React, { createContext, useContext, useState, useEffect } from "react";

interface PreloaderContextType {
  isExiting: boolean;
  isFinished: boolean;
  setIsExiting: (val: boolean) => void;
  setIsFinished: (val: boolean) => void;
}

const PreloaderContext = createContext<PreloaderContextType>({
  isExiting: false,
  isFinished: false,
  setIsExiting: () => {},
  setIsFinished: () => {},
});

export const usePreloader = () => useContext(PreloaderContext);

export const PreloaderProvider = ({ children }: { children: React.ReactNode }) => {
  const [isExiting, setIsExiting] = useState(false);
  const [isFinished, setIsFinished] = useState(false);

  return (
    <PreloaderContext.Provider value={{ isExiting, isFinished, setIsExiting, setIsFinished }}>
      {children}
    </PreloaderContext.Provider>
  );
};
